import React from 'react';
import './AboutPageNewLandingSection.scss';
import logoImage from '../../../assets/images/branding/gg_landing_brand.png';

const AboutPageNewLandingSection = () => {
  return (
    <section className="about-landing-section">
      <div className="hero-content">
        <div className="main-text">
          <h1 className="bringing-text">
            Bringing
          </h1>
          <h1 className="revolution-text">
            The Freelance Revolution.
          </h1>
          <h1 className="india-text">
            In India
          </h1>
        </div>
        
        {/* GenieGig Logo */}
        <div className="logo-section">
          <div className="logo-container">
            <img src={logoImage} alt="GenieGig Logo" className="logo-image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPageNewLandingSection;
